"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.grey = void 0;
var ThemeShadows_1 = __importDefault(require("./ThemeShadows"));
exports.grey = {
    50: '#F7F9FF',
    100: '#EEF2F8',
    200: '#E6EAF0',
    300: '#D3D9E1',
    400: '#BDC4CD',
    500: '#A1A8B0',
    600: '#828994',
    700: '#626871',
    800: '#474C54',
    900: '#1D2025',
    A100: '#D5D5D5',
    A200: '#AAAAAA',
    A400: '#303030',
    A700: '#616161',
};
var defaults = {
    palette: {
        type: 'light',
        primary: {
            main: '#1d78c3',
        },
        secondary: {
            main: '#dc4545',
        },
        background: {
            default: '#F7F9FF',
        },
        success: {
            main: '#57D582',
            light: '#6AE99C',
            dark: '#30A46C',
        },
        grey: exports.grey,
    },
    shape: {
        borderRadius: 10,
    },
    spacing: 0,
    shadows: ThemeShadows_1.default,
    overrides: {
        MuiTextField: {},
        MuiFilledInput: {
            root: {
                backgroundColor: exports.grey[100],
                '&:hover': {
                    backgroundColor: exports.grey[200],
                },
                '&.Mui-focused': {
                    backgroundColor: exports.grey[200],
                },
            },
        },
    },
    typography: {
        h1: {
            fontSize: '3rem',
        },
        h2: {
            fontSize: '2.5rem',
        },
        h3: {
            fontSize: '1.8rem',
        },
        h4: {
            fontSize: '1.6rem',
        },
        h5: {
            fontSize: '1.3rem',
        },
        h6: {
            fontSize: '1.25rem',
        },
        fontWeightRegular: 400,
        fontWeightLight: 300,
        fontWeightBold: 900,
        fontWeightMedium: 700,
        fontFamily: 'Lato',
    },
};
exports.default = defaults;
//# sourceMappingURL=ThemeDefaults.js.map